import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Grid,
  Button,
  IconButton,
  ButtonBase,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from "@mui/material";
import AdminHeader from "../../../layouts/AdminLayout/components/AdminHeader/AdminHeader";
import avatarUrl from "./../../../assets/images/dummy/profile.svg";
import { store } from "../../../store";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../../utils/types";
import { useEffect, useState } from "react";
import API from "../../../api/axios";
import DataLoader from "../../../shared/DataLoader/DataLoader";
import EditBlueIcon from "./../../../assets/images/icons/editBlue.svg";
import ConfirmationDialog from "../../../components/ConfirmationDialog/ConfirmationDialog";
import { useDispatch } from "react-redux";
import { setToast } from "../../../store/slices/toastSlice";
import { setUser } from "../../../store/slices/userSlice";
import ManageDamainsModal from "./ManageDomains/ManageDomainsModal";
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const Profile = () => {
  const navigate = useNavigate();
  const state: any = getUser();
  const [profileData, setProfileData] = useState<any>([]);
  const [interviewerProfileDetails, setInterviewerProfileDetails] = useState<any>(null);
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [ManageDamainsModalLoading, setManageDamainsModalLoading] = useState<boolean>(false);
  const [isManageDamainsModalOpen, setIsManageDamainsModalOpen] = useState<boolean>(false);
  const [isEditBankModalOpen, setIsEditBankModalOpen] = useState<boolean>(false);
  const [updateBankLoading, setUpdateBankLoading] = useState<boolean>(false);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState<boolean>(false);
  const [updateProfileLoading, setUpdateProfileLoading] = useState<boolean>(false);
  const [stateData, setStateData] = useState<any[]>([]);
  const [districtData, setDistrictData] = useState<any[]>([]);
  const [selectedStateId, setSelectedStateId] = useState<number | string>("");
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.style.backgroundColor = "#f5f5f5";

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleManageDamainsModalClick = () => {
    setIsManageDamainsModalOpen(true);
  };

  const handleManageDamainsModalCancel = () => {
    setIsManageDamainsModalOpen(false);
  };

  const handleManageDamainsModalConfirm = async () => {
    // setManageDamainsModalLoading(true);
       
    // setManageDamainsModalLoading(false);
      setIsManageDamainsModalOpen(false);
    }

  const handleEditBankModalOpen = () => {
    setIsEditBankModalOpen(true);
  };

  const handleEditBankModalClose = () => {
    setIsEditBankModalOpen(false);
  };

  const handleEditProfileModalOpen = () => {
    setIsEditProfileModalOpen(true);
  };

  const handleEditProfileModalClose = () => {
    setIsEditProfileModalOpen(false);
  };

  const fetchStates = async () => {
    try {
      const response = await API.get(
        "/items/master_states?fields=id,state_name&sort[]=state_name&limit=-1"
      );
      setStateData(response?.data?.data || []);
    } catch (error) {
      // Failed to fetch states
    }
  };

  const fetchDistricts = async (stateId: any) => {
    try {
      const response = await API.get(
        `/items/master_districts?fields=id,state_id,district_name&filter[state_id]=${stateId}&sort[]=state_id&sort[]=district_name&limit=-1`
      );
      setDistrictData(response?.data?.data || []);
    } catch (error) {
      // Failed to fetch districts
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    if (profileData?.user?.state_id?.id) {
      setSelectedStateId(profileData?.user?.state_id?.id);
    }
  }, [profileData]);

  useEffect(() => {
    if (selectedStateId) {
      fetchDistricts(selectedStateId);
    } else {
      setDistrictData([]);
    }
  }, [selectedStateId]);

  const handleUpdateProfileDetails = async (values: any, { setSubmitting }: any) => {
    setUpdateProfileLoading(true);
    try {
      const payload = {
        first_name: values?.first_name || "",
        last_name: values?.last_name || "",
        state_id: values?.state_id || "",
        district_id: values?.district_id || "",
        address: values?.address || "",
      };

      const response = await API.post("/um/interviewer/update-profile", payload);

      let currentSessionData = JSON.parse(sessionStorage.getItem("data") || "{}");
      if (currentSessionData && currentSessionData.user) {
        currentSessionData.user.first_name = payload.first_name;
        currentSessionData.user.last_name = payload.last_name;
        currentSessionData.user.fullname = `${payload.first_name} ${payload.last_name}`.trim();
        sessionStorage.setItem("data", JSON.stringify(currentSessionData));
        dispatch(setUser({ ...currentSessionData }));
      }

      dispatch(
        setToast({
          message: response?.data?.message || "Profile updated successfully",
          severity: "success",
          open: true,
        })
      );
      await getProfile();
      setIsEditProfileModalOpen(false);
    } catch (error: any) {
      dispatch(
        setToast({
          message: error?.response?.data?.message || error?.response?.data?.error?.[0]?.message || "Failed to update profile",
          severity: "error",
          open: true,
        })
      );
    } finally {
      setUpdateProfileLoading(false);
      setSubmitting(false);
    }
  };

  const fetchInterviewerProfileDetails = async (userId: any) => {
    if (!userId) {
      setInterviewerProfileDetails(null);
      return;
    }

    try {
      const interviewerProfileResponse = await API.post("/um/view_profile", {
        user_id: userId,
      });
      setInterviewerProfileDetails(interviewerProfileResponse?.data?.data?.user);
    } catch (error) {
      // Failed to fetch interviewer profile details
    }
  };

  const handleUpdateBankDetails = async (values: any, { setSubmitting }: any) => {
    setUpdateBankLoading(true);
    try {
      const payload = {
        pan_no: values?.pan_no || "",
        gst_no: values?.gst_no || "",
        beneficiary_name: values?.beneficiary_name || "",
        beneficiary_account_no: values?.beneficiary_account_no || "",
        bank_name: values?.bank_name || "",
        branch: values?.branch || "",
        ifsc_code: values?.ifsc_code || "",
      };

      const response = await API.post("/um/update-bank-details", payload);
      dispatch(
        setToast({
          message: response?.data?.message || "Bank & GST details updated successfully",
          severity: "success",
          open: true,
        })
      );
      await fetchInterviewerProfileDetails(profileData?.user?.id);
      setIsEditBankModalOpen(false);
    } catch (error: any) {
      dispatch(
        setToast({
          message: error?.response?.data?.error[0]?.message || "Failed to update bank details",
          severity: "error",
          open: true,
        })
      );
    } finally {
      setUpdateBankLoading(false);
      setSubmitting(false);
    }
  };

  const getProfile = async () => {
    setDataLoading(true);
    try {
      let response = await API.get("/um/my_profile");
      const profileResponseData = response?.data?.data;
      setProfileData(profileResponseData);

      if (
        profileResponseData?.role_details?.role_code === "interviewer" &&
        profileResponseData?.user?.id
      ) {
        await fetchInterviewerProfileDetails(profileResponseData?.user?.id);
      } else {
        setInterviewerProfileDetails(null);
      }
    } catch (error) {
      // Failed to fetch profile data
    } finally {
      setDataLoading(false);
    }
  };
  useEffect(() => {
    getProfile();
  }, []);

  const fullname = (firstName: string, lastName: string) => {
    if (!firstName) {
      return "NA";
    }
    return firstName + " " + lastName;
  };

  // console.log(profileData?.user?.domains[0]?.domain_id?.name,"profileData?.user?.domains");
  const interviewerBankDetails = interviewerProfileDetails?.user_bank_details?.[0];
  const bankFormInitialValues = {
    pan_no: interviewerBankDetails?.pan_no || "",
    gst_no: interviewerBankDetails?.gst_no || "",
    beneficiary_name: interviewerBankDetails?.beneficiary_name || "",
    beneficiary_account_no: interviewerBankDetails?.beneficiary_account_no || "",
    bank_name: interviewerBankDetails?.bank_name || "",
    branch: interviewerBankDetails?.branch || "",
    ifsc_code: interviewerBankDetails?.ifsc_code || "",
  };
  const bankDetailsValidationSchema = Yup.object({
    beneficiary_name: Yup.string().nullable().matches(
      /^[a-zA-Z\s]+$/,
      "Only alphabets and spaces are allowed"
    ),
    beneficiary_account_no: Yup.string().nullable().matches(
      /^\d{9,18}$/,
      "Account number must be between 9 and 18 digits"
    ),
    bank_name: Yup.string().nullable().matches(
      /^[a-zA-Z\s]+$/,
      "Only alphabets and spaces are allowed"
    ),
    branch: Yup.string().nullable().matches(
      /^[a-zA-Z0-9\s]+$/,
      "Only alphanumeric characters and spaces are allowed"
    ),
    ifsc_code: Yup.string().nullable().matches(
      /^[A-Z]{4}0[A-Z0-9]{6}$/,
      "Invalid IFSC code format"
    ),
    gst_no: Yup.string().nullable().matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST Number format"
    ),
    pan_no: Yup.string().nullable().matches(
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      "Invalid PAN Number format"
    ),
  });

  const profileFormInitialValues = {
    first_name: profileData?.user?.first_name || "",
    last_name: profileData?.user?.last_name || "",
    state_id: profileData?.user?.state_id?.id || "",
    district_id: profileData?.user?.district_id?.id || "",
    address: profileData?.user?.address || "",
  };

  const profileValidationSchema = Yup.object({
    first_name: Yup.string()
      .min(2, "Minimum 2 characters required")
      .max(50, "Maximum 50 characters allowed")
      .required("First Name is required")
      .matches(/^[a-zA-Z\s.]+$/, "Special characters are not allowed"),
    last_name: Yup.string()
      .min(2, "Minimum 2 characters required")
      .max(50, "Maximum 50 characters allowed")
      .nullable()
      .matches(/^[a-zA-Z]+$/, "Special characters are not allowed"),
    state_id: Yup.string().required("State is required"),
    district_id: Yup.string().required("District is required"),
    address: Yup.string()
      .nullable()
      .max(500, "Maximum 500 Characters only allowed")
      .min(10, "Minimum 10 characters needed")
      .matches(/^(?!.*<[^>]+>).*/, "HTML tags are not allowed"),
  });

  return (
    <Container maxWidth="xl">
      <AdminHeader />

      <Box
        sx={{
          marginTop: "8rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography fontSize={"25px"} color="#000" fontWeight={500}>
            View Profile
          </Typography>
          
          <Box sx={{ display: "flex", gap: "10px", alignItems: "end", justifyContent:"" }}>
            <Button
              sx={{ fontSize: ".8rem" }}
              onClick={() => navigate("/admin/dashboard")}
            >
              Go to Dashboard
            </Button>
            {profileData?.role_details?.role_code === "interviewer" && (
              <Button
                variant="contained"
                color="secondary"
                sx={{ marginTop: "1.5rem", fontSize: ".8rem", marginLeft: "10px" }}
                onClick={handleEditProfileModalOpen}
                >
                Edit Profile
              </Button>
            )}
            
          </Box>
        </Box>
        { }
        <Card
          className="custom__card"
          sx={{
            marginTop: "1.5rem",
            backgroundColor: "#fff",
          }}
        >
          <CardContent sx={{ backgroundColor: "#fff" }}>
            {dataLoading ? (
              <Box height={"300px"}>
                <DataLoader />
              </Box>
            ) : (
              <Grid container spacing={2}>
                {/* Profile Picture and Name */}
                <Grid
                  item
                  xs={12}
                  sm={2}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                >
                  {/* image url  */}
                  {/* <Avatar
                    src={(profileData?.role_details?.role_code=='candidate'|| profileData?.role_details?.role_code=='bidder')?(profileData?.user?.infracon_kp_photo):avatarUrl}
                    alt="Profile"
                    sx={{ width: 100, height: 100 }}
                  /> */}
                  {(profileData?.role_details?.role_code=='candidate'|| profileData?.role_details?.role_code=='bidder')?
                  <Avatar src={profileData?.user?.infracon_kp_photo||AccountCircleIcon} className="profile-avatar" sx={{ width: 100, height: 100 }} />:
                  <Avatar sx={{ width: 100, height: 100 }} className="profile-avatar">
                      <PersonIcon sx={{ fontSize: 100 }} />
                  </Avatar>}
                  <Typography
                    variant="h6"
                    sx={{ mt: 2, textTransform: "capitalize" }}
                  >
                    {fullname(
                      profileData?.user?.first_name,
                      profileData?.user?.last_name
                    )}
                  </Typography>
                </Grid>

                {/* User Details */}
                <Grid item xs={12} sm={10}>
                  <Grid container spacing={2}>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        Full Name
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                        textTransform={"capitalize"}
                      >
                        {fullname(
                          profileData?.user?.first_name,
                          profileData?.user?.last_name
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        Mobile Number
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.user?.mobile || "NA"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        Email
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.user?.email || "NA"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        User Role
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.role_details?.name || "NA"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        Gender
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.user?.gender || "NA"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        State
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.user?.state_id?.state_name || "NA"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} marginBottom={"1rem"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                      >
                        District
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.user?.district_id?.district_name || "NA"}
                      </Typography>
                    </Grid>
                    { profileData?.role_details?.role_code === "interviewer" &&
                    <Grid item xs={4} marginBottom={"1rem"} paddingTop={"1rem !important"}>
                      <Typography
                        variant="subtitle2"
                        color="#606060"
                        fontSize={"14px"}
                        fontWeight={400}
                        padding={0}
                        margin={0}
                      >
                        Mapped Domains
                        <Tooltip title="Manage Domains " arrow>
                            {/* <IconButton
                              size="small"
                              className="icons"
                              disabled={false}
                              sx={{
                                color:"#326FB4"
                              }}
                              onClick={() =>
                                // Open domain modal
                              }
                            >
                              <img src={EditIcons} style={{backgroundColor:"#326FB4 !important"}} className="edit" /> Manage Domains
                            </IconButton> */}
                            <ButtonBase
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              color: '#326FB4',
                              fontSize: '14px',
                              padding: '6px',
                              borderRadius: '4px',
                              height:"1rem",
                              '&:hover': {
                                // backgroundColor: 'rgba(50, 111, 180, 0.04)',
                                backgroundColor: 'rgba(8, 15, 24, 0.04) !important',
                              }
                            }}
                            onClick={() => {handleManageDamainsModalClick()}}
                          >
                            <img src={EditBlueIcon} className="edit" />
                            <span>Manage Domains</span>
                          </ButtonBase>
                          </Tooltip>
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#000"
                        fontSize={"13px"}
                        fontWeight={600}
                      >
                        {profileData?.user?.domains.length>0 ? profileData?.user?.domains?.map((domain:any, index:any, domains:any)=><>{domain?.domain_id?.name}{index < domains.length-1 ? "," : ""} </>) : "NA"}
                      </Typography>
                    </Grid>}
                    {profileData?.role_details?.role_code === "interviewer" && (
                      <>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            GST No.
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.gst_no || "NA"}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            PAN No.
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.pan_no || "NA"}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            Beneficiary Name
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.beneficiary_name || "NA"}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            Beneficiary Account No
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.beneficiary_account_no || "NA"}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            Bank Name
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.bank_name || "NA"}
                          </Typography>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: "1.5rem", fontSize: ".8rem" }}
                            onClick={handleEditBankModalOpen}
                          >
                            Edit Bank & GST
                          </Button>
                          {/* 
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: "1.5rem", fontSize: ".8rem", marginLeft: "10px" }}
                            onClick={handleEditProfileModalOpen}
                          >
                            Edit Profile
                          </Button>
                          */}
                        </Grid>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            Branch
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.branch || "NA"}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} marginBottom={"1rem"}>
                          <Typography
                            variant="subtitle2"
                            color="#606060"
                            fontSize={"14px"}
                            fontWeight={400}
                          >
                            IFSC Code
                          </Typography>
                          <Typography
                            variant="body1"
                            color="#000"
                            fontSize={"13px"}
                            fontWeight={600}
                          >
                            {interviewerBankDetails?.ifsc_code || "NA"}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {/* <Grid item xs={4} marginBottom={"1rem"}>
                    <Typography
                      variant="subtitle2"
                      color="#606060"
                      fontSize={"14px"}
                      fontWeight={400}
                    >
                      Designation
                    </Typography>
                    <Typography variant="body1" color="#000" fontSize={"13px"}>
                      {state?.user?.designation || "NA"}
                    </Typography>
                  </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Card>
      </Box>
      {/* <AuthFooter /> */}
      <ManageDamainsModal
        open={isManageDamainsModalOpen}
        onClose={handleManageDamainsModalCancel}
        onConfirm={handleManageDamainsModalConfirm}
        title={ "Manage Domains"}
        interviewerRole={profileData?.role_details?.role_code === "interviewer"}
        mappedDomains={profileData?.user?.domains}
        loading={ManageDamainsModalLoading}
      />
      <Formik
        initialValues={bankFormInitialValues}
        enableReinitialize
        validationSchema={bankDetailsValidationSchema}
        onSubmit={handleUpdateBankDetails}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isValid,
          dirty,
          isSubmitting,
        }) => (
          <Dialog
            maxWidth="sm"
            fullWidth
            open={isEditBankModalOpen}
            onClose={handleEditBankModalClose}
            PaperProps={{
              sx: {
                borderRadius: "15px",
              },
            }}
          >
            <Form onSubmit={handleSubmit}>
              <DialogTitle>Edit Bank & GST</DialogTitle>
              <DialogContent>
                <Grid container spacing={2} marginTop={"0.2rem"}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="PAN No."
                      name="pan_no"
                      value={values?.pan_no}
                      onChange={(e) => setFieldValue("pan_no", e.target.value.toUpperCase())}
                      onBlur={handleBlur}
                      error={touched?.pan_no && Boolean(errors?.pan_no)}
                      helperText={touched?.pan_no ? (errors?.pan_no as string) : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="GST No."
                      name="gst_no"
                      value={values?.gst_no}
                      onChange={(e) => setFieldValue("gst_no", e.target.value.toUpperCase())}
                      onBlur={handleBlur}
                      error={touched?.gst_no && Boolean(errors?.gst_no)}
                      helperText={touched?.gst_no ? (errors?.gst_no as string) : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Beneficiary Name"
                      name="beneficiary_name"
                      value={values?.beneficiary_name}
                      onChange={(e) => setFieldValue("beneficiary_name", e.target.value)}
                      onBlur={handleBlur}
                      error={
                        touched?.beneficiary_name && Boolean(errors?.beneficiary_name)
                      }
                      helperText={
                        touched?.beneficiary_name
                          ? (errors?.beneficiary_name as string)
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Beneficiary Account No"
                      name="beneficiary_account_no"
                      value={values?.beneficiary_account_no}
                      onChange={(e) =>
                        setFieldValue("beneficiary_account_no", e.target.value)
                      }
                      onBlur={handleBlur}
                      error={
                        touched?.beneficiary_account_no &&
                        Boolean(errors?.beneficiary_account_no)
                      }
                      helperText={
                        touched?.beneficiary_account_no
                          ? (errors?.beneficiary_account_no as string)
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Bank Name"
                      name="bank_name"
                      value={values?.bank_name}
                      onChange={(e) => setFieldValue("bank_name", e.target.value)}
                      onBlur={handleBlur}
                      error={touched?.bank_name && Boolean(errors?.bank_name)}
                      helperText={touched?.bank_name ? (errors?.bank_name as string) : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Branch"
                      name="branch"
                      value={values?.branch}
                      onChange={(e) => setFieldValue("branch", e.target.value)}
                      onBlur={handleBlur}
                      error={touched?.branch && Boolean(errors?.branch)}
                      helperText={touched?.branch ? (errors?.branch as string) : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="IFSC Code"
                      name="ifsc_code"
                      value={values?.ifsc_code}
                      onChange={(e) => setFieldValue("ifsc_code", e.target.value.toUpperCase())}
                      onBlur={handleBlur}
                      error={touched?.ifsc_code && Boolean(errors?.ifsc_code)}
                      helperText={touched?.ifsc_code ? (errors?.ifsc_code as string) : ""}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ padding: "1rem 1.5rem" }}>
                <Button
                  onClick={handleEditBankModalClose}
                  sx={{ marginRight: "10px", fontSize: ".8rem" }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={updateBankLoading || isSubmitting || !(isValid && dirty)}
                  sx={{ fontSize: ".8rem" }}
                >
                  {updateBankLoading ? "Updating..." : "Update"}
                </Button>
              </DialogActions>
            </Form>
          </Dialog>
        )}
      </Formik>
      <Formik
        initialValues={profileFormInitialValues}
        enableReinitialize
        validationSchema={profileValidationSchema}
        onSubmit={handleUpdateProfileDetails}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isValid,
          dirty,
          isSubmitting,
        }) => (
          <Dialog
            maxWidth="sm"
            fullWidth
            open={isEditProfileModalOpen}
            onClose={handleEditProfileModalClose}
            PaperProps={{
              sx: {
                borderRadius: "15px",
              },
            }}
          >
            <Form onSubmit={handleSubmit}>
              <DialogTitle>Edit Profile</DialogTitle>
              <DialogContent>
                <Grid container spacing={2} marginTop={"0.2rem"}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="First Name*"
                      name="first_name"
                      value={values?.first_name}
                      onChange={(e) => setFieldValue("first_name", e.target.value)}
                      onBlur={handleBlur}
                      error={touched?.first_name && Boolean(errors?.first_name)}
                      helperText={touched?.first_name ? (errors?.first_name as string) : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="last_name"
                      value={values?.last_name}
                      onChange={(e) => setFieldValue("last_name", e.target.value)}
                      onBlur={handleBlur}
                      error={touched?.last_name && Boolean(errors?.last_name)}
                      helperText={touched?.last_name ? (errors?.last_name as string) : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={stateData}
                      getOptionLabel={(option: any) => option?.state_name || ""}
                      value={stateData?.find((val: any) => val?.id === values?.state_id) || null}
                      onChange={(event, value) => {
                        setFieldValue("state_id", value ? value?.id : "");
                        setFieldValue("district_id", "");
                        setSelectedStateId(value ? value?.id : "");
                      }}
                      onBlur={() => setFieldTouched("state_id", true)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="State*"
                          error={touched?.state_id && Boolean(errors?.state_id)}
                          helperText={touched?.state_id ? (errors?.state_id as string) : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={districtData}
                      getOptionLabel={(option: any) => option?.district_name || ""}
                      value={districtData?.find((val: any) => val?.id === values?.district_id) || null}
                      onChange={(event, value) => {
                        setFieldValue("district_id", value ? value?.id : "");
                      }}
                      onBlur={() => setFieldTouched("district_id", true)}
                      disabled={!values?.state_id}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="District*"
                          error={touched?.district_id && Boolean(errors?.district_id)}
                          helperText={touched?.district_id ? (errors?.district_id as string) : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Address"
                      name="address"
                      value={values?.address}
                      onChange={(e) => setFieldValue("address", e.target.value)}
                      onBlur={handleBlur}
                      error={touched?.address && Boolean(errors?.address)}
                      helperText={touched?.address ? (errors?.address as string) : ""}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ padding: "1rem 1.5rem" }}>
                <Button
                  onClick={handleEditProfileModalClose}
                  sx={{ marginRight: "10px", fontSize: ".8rem" }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={updateProfileLoading || isSubmitting || !(isValid && dirty)}
                  sx={{ fontSize: ".8rem" }}
                >
                  {updateProfileLoading ? "Updating..." : "Update"}
                </Button>
              </DialogActions>
            </Form>
          </Dialog>
        )}
      </Formik>
    </Container>
  );
};

export default Profile;
